export const STORAGE_KEYS = {
  USER_TOKEN: "userToken",
  STREAM_TOKEN: "streamToken",
  USER_DATA: "userData",
  SECURE_TOKEN: "app_secure_data_v3",
  USER_ID: "user_id",
  LANGUAGE: "language",
  ROLES: "userRoles",
} as const;

export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "ja", name: "Japanese" },
  { code: "vi", name: "Vietnamese" },
  { code: "id", name: "Indonesian" },
  { code: "th", name: "Thai" }, // Thailand
  { code: "km", name: "Khmer" }, // Cambodia
  { code: "bn", name: "Bengali" }, // Bangladesh
  { code: "my", name: "Burmese" }, // Myanmar
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

